import React from 'react'
import { FaLinkedinIn, FaGithub, FaChess } from 'react-icons/fa';
import './footer.css'

const Footer = () => {
  return (
    <footer>
      <a href='footer_logo' className='footer_logo'>Thu Mai</a>

      <ul className='permalinks'>
        <li><a href='#home'>Home</a></li>
        <li><a href='#about'>About</a></li>
        <li><a href='#experience'>Experience</a></li>
        <li><a href='#services'>Services</a></li>
        <li><a href='#portfolio'>Portfolio</a></li>
        <li><a href='#testimonials'>Testimonials</a></li>
        <li><a href='#contact'>Contact</a></li>
      </ul>

      <div className="footer_socials">
        <a href='https://www.linkedin.com/in/mnathuw/' target='_blank' rel="noreferrer"><FaLinkedinIn /></a>
        <a href='https://github.com/mnathuw' target='_blank' rel="noreferrer"><FaGithub /></a>
        <a href='https://www.chess.com/member/mnathu98' target='_blank' rel="noreferrer"><FaChess /></a>
      </div>

      <div className="footer_copyright">
        <small>&copy;2025 Thu Mai. All rights reserved.
        </small>
      </div>
    </footer>
  )
}

export default Footer